export enum FlutterEventType {
  Navigation = 'navigation'
}